import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
    import { useEffect, useState } from "react";
 import Swal from "sweetalert2";
 import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

 
import {
    faFacebookF,
    faTwitter,
    faInstagram,
    faYoutube,
    faGithub
} from "@fortawesome/free-brands-svg-icons";
import "../../assets/css/footer.css"
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import instaLogo from "../../assets/images/icon/insta-png.png";
 
const Footer = () => {
 
const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);
const [filteredCities, setFilteredCities] = useState([]);
const [filteredcategories, setFilteredCategories] = useState([]);
 
 
const [categories, setCategories] = useState([]);
 const [email, setEmail] = useState(""); // ❌ WRONG
  const [loading, setLoading] = useState(false);
 
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/arts-categories")
    .then(res => res.json())
    .then(data => {
      setCategories(data.categories);
    })
    .catch(err => console.log(err));
}, []);
 
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/arts-categories-with-tutors")
    .then(res => res.json())
    .then(data => {
      if (data.success) setFilteredCategories(data.categories);
    });
}, []);
 
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/cities-with-tutors")
    .then(res => res.json())
    .then(data => {
      if (data.success) setFilteredCities(data.cities);
    });
}, []);
 
const handleSubscribe = async (e) => {
  e.preventDefault();
 
  if (!email) {
    Swal.fire("Oops!", "Please enter your email address", "warning");
    return;
  }
 
  try {
    setLoading(true);
 
    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/v1/subscribe",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );
 
    const data = await res.json();
 
    if (data.success) {
      Swal.fire({
        icon: "success",
        title: "Subscribed Successfully 🎉",
        text: data.message,
        width: 380,
  heightAuto: false,
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  allowOutsideClick: false,
  allowEscapeKey: false,
      });
      setEmail("");
    } else {
      Swal.fire("Info", data.message, "info");
    }
  } catch {
    Swal.fire("Error", "Something went wrong. Please try again.", "error");
  } finally {
    setLoading(false);
  }
};
 
 
    return (
       
        <>
        <style>
                {`
                .social {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    color: white;
                    font-size: 16px;
                    transition: 0.3s ease-in-out;
                }
                .social.fb { background-color: #1877F2; }
                .social.fb:hover { background-color: #0d5ec4; }
 
                .social.tw { background-color: #1DA1F2; }
                .social.tw:hover { background-color: #0c8ad6; }
 
                .social.ig {
                    background: radial-gradient(circle at 30% 110%, #ffdb8c 0%, #e76820 25%, #dc2d73 50%, #cc2bff 75%, #3a4bff 100%);
                }
                .social.ig:hover { transform: scale(1.15); }
 
                .social.yt { background-color: #FF0000; }
                .social.yt:hover { background-color: #cc0000; }
 
                .social.gh { background-color: #24292e; }
                .social.gh:hover { background-color: #000; }
                .social-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
//   width:100px;
}
 
.social-text {
  font-size: 13px;
  color: white;
}
 
 
 
                `}
            </style>
        <div className="news-footer-wrap"  style={{ background: "transparent" }}>
 
            {/* NEWSLETTER SECTION */}
            <div className="news-letter">
                <div className="container">
                    <div className="section-wrapper">
                        <div className="news-title">
                            <h3>Want Us To Email You About Special Offers And Updates?</h3>
                        </div>
 
                        <div className="news-form">
 
 
                            <form onSubmit={handleSubscribe}>
  <div className="nf-list">
    <input
      type="email"
      placeholder="Enter Your Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required  style={{width:"100%"}}
    />
 
    {/* <button
      type="submit"
      disabled={loading}
      style={{ backgroundColor: "#f66c03", color: "white" }}
    >
      {loading ? "Subscribing..." : "Subscribe Now"}
    </button> */}
 
    <input type="submit" disabled={loading} value="Subscribe Now" style={{backgroundColor:"#f66c03"}} />
  </div>
</form>
 
                        </div>
                    </div>
                </div>
            </div>
 
 
            {/* FOOTER CONTENT */}
            <footer>
                <div className="footer-top  pt-0">
                    <div className="container">
                        {/* <div className="row g-4 row-cols-xl-4 row-cols-md-2 row-cols-1 justify-content-center"> */}
                        {/* <div className="footer-columns justify-content-center">
 
 
                         
 
                        </div> */}
                  {/* <img src={instaLogo} alt="Instagram" className="insta-img" /> */}
                 
                         
                         <div className="footer-columns justify-content-center" >
 
                              {/* QUICK LINKS */}
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>Quick Links</h4>
                                            </div>
                                            <ul className="lab-ul" style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                                                <li><Link to="/about"style={{ color: "white" }}>About Us</Link></li>
                                                <li><Link to="/contact" style={{ color: "white" }}>Contact Us</Link></li>
                                                <li><Link to="/terms" style={{ color: "white" }}>Terms & Conditions</Link></li>
                                                <li><Link to="/privacypolicy" style={{ color: "white" }}>Privacy Policy</Link></li>
                                                <li>
    <Link to="/advertise" style={{ color: "white" }}>
      Advertise With Us
    </Link>
  </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
 
                            {/* CONTACT INFO */}
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>Contact Info</h4>
                                            </div>
<ul className="lab-ul" style={{ display: "flex " , flexDirection: "row", gap: "20px",color:"white" }}>
<li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px",  fontWeight:"bold"}}>Firm Name :</div>
   
  
       
      <h6 style={{color:"#ffcc00", fontSize:"13px"}}> VKAKSHAAHA EDUINSTITUTIONS LLP</h6>
      
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

<FaEnvelope />
<span>Kalakakshaaha@gmail.com</span>
</div>
</li>
 
                                                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
<FaPhoneAlt />
<span>+91 9866673323</span>
</div>
</li>
</ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
 
                            {/* QUICK Cities */}
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content" >
                                            <div className="title">
                                                <h4> Find tutors By City</h4>
                                            </div>
                                               <ul
  className="lab-ul"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(10, auto)",   // 10 items per row
    gap: "8px 20px",
    color: "white",
    padding: 0,
    margin: 0,
    listStyle: "none"
  }}
>
                                    {filteredCities.slice(0, 10).map((city) => (
                                        <li key={city.city_id}>
                                        <Link
                                            to={`/tutors/all?q=${encodeURIComponent(city.city_name)}`}
                                            style={{ color: "white" }}
                                        >
                                            {city.city_name}
                                        </Link>
                                        </li>
                                    ))}
                                    </ul>
 
                                        </div>
                                    </div>
                                </div>
                            </div>
 
                            {/* categories links */}
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>Find Tutor By  Category</h4>
                                            </div>
                                           
                                        <div style={{ display: "flex", gap: "40px" }}>
  
                                                              {/* FIRST 10 */}
                                                              <ul className="lab-ul" style={{ listStyle: "none", padding: 0 }}>
                                                                {filteredcategories.slice(0, 10).map(cat => (
                                                                  <li key={cat.category_id}>
                                                                    <Link
                                                                      to={`/tutors/${cat.category_name}`}
                                                                      style={{ color: "white" }}
                                                                    >
                                                                      {cat.category_name}
                                                                    </Link>
                                                                  </li>
                                                                ))}
                                                              </ul>

                                                              {/* NEXT 10 */}
                                                              <ul className="lab-ul" style={{ listStyle: "none", padding: 0 }}>
                                                                {filteredcategories.slice(10, 20).map(cat => (
                                                                  <li key={cat.category_id}>
                                                                    <Link
                                                                      to={`/tutors/${cat.category_name}`}
                                                                      style={{ color: "white" }}
                                                                    >
                                                                      {cat.category_name}
                                                                    </Link>
                                                                  </li>
                                                                ))}
                                                              </ul>

</div>
 
              
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                           
                           
 
                        </div>
 
<div className="follow-section">
  <h3 className="follow-title">Follow Us</h3>

  <ul className="follow-list">
    <li className="social-item">
      <a
        href="https://youtu.be/3OKhAMMOJB0?si=RwuNZMvvT_v422f0"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/images/about/teluguimg3.png"
          alt="Telugu Music Classes"
        />
      </a>
    </li>

    <li className="social-item">
      <a
        href="https://youtu.be/x5YOxuTsuw4?si=LVzlrX2ys4-qlTDb"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/images/about/factsimg3.png"
          alt="Facts Vlogs"
        />
      </a>
    </li>
  </ul>
</div>

 
                    </div>
                </div>
               
 
                {/* FOOTER BOTTOM */}
                <div className="footer-bottom style-2" style={{ background: "transparent" }}>
                    <div className="container">
                        <div className="section-wrapper" >
                            <p style={{ color: "white" }}>
                                {/* © {new Date().getFullYear()} <Link to="/" style={{ color: "white" }}>Kalakaaksha</Link>.
                                Designed by SANVIMA. */}
                               © 2026 Kalakakshaaha. All Rights Reserved.
                            </p>
                        </div>
                    </div>
                </div>
 
            </footer>
        </div>
        </>
    );
};
 
export default Footer;